<template>
	<div class="Pursh componetself" v-loading="pLoad">
		<div class="body_btns headbtn">
			<vxe-button type="text" class="tool-btn _icon_button" title="确认" @click="DoRequest(1)"
				:loading="DoLoad" :disabled="DoLoad||AntiLoad||transLoad||selectLog">
				<i class="iconfont icon-publish iconSize "></i>确认
			</vxe-button>
			<vxe-button type="text" class="tool-btn _icon_button" title="反确认" @click="DoRequest(2)"
				:loading="AntiLoad" :disabled="AntiLoad||DoLoad||transLoad||selectLog">
				<i class="iconfont icon-shanchu iconSize "></i>反确认
			</vxe-button>
			<vxe-button type="text" class="tool-btn _icon_button" title="生成送货单" v-if="NextDoc=='01'"
				@click="TransDoRequest" :loading="transLoad"
				:disabled="AntiLoad||DoLoad||transLoad||selectLog"
				>
				<i class="iconfont icon-recovery iconSize "></i>生成送货单
			</vxe-button>
			<template v-if="!HashPlan">
				<vxe-button type="text" class="tool-btn _icon_button" title="标签打印"
					@click="showCreateModal(true)" :loading="VDAPRILoad" :disabled="transLoad||selectLog||VDAPRILoad||cload"
					>
					<i class="iconfont icon-print iconSize "></i>标签打印
				</vxe-button>
				<vxe-button type="text" class="tool-btn _icon_button" title="已生成标签查看"
					:loading="cload" @click="VDAPRCreatedFn"
					:disabled="transLoad||selectLog||VDAPRILoad||cload">
					<i class="iconfont icon-print iconSize "></i>已生成标签查看
				</vxe-button>
			</template>
			
		</div>
		<div class="componet_header">
			<div class="filter">
				<template v-for="(item,index) in  filterList">
					<div class="filter_item" :key="index">
						<c-filter :item="item" 
							:form="filterForm" :line="true" :textMini="45" :VailShow="filterShow"></c-filter>
					</div>
				</template>
			</div>
			<div class="btns">
				<el-button type="primary" class="pursh_mainBtn" :loading="selectLog" :disabled="selectLog" @click="selectOrder">查询</el-button>
			</div>
		</div>
		<div class="componet_body">
			<!-- <div class="body_btns">
				<el-button type="primary" class="pursh_mainBtn">查询</el-button>
			</div> -->
			<div class="body_content">
				<!-- checkbox -->
				<c-table ref="ctablemain" :table="table" :coltype="'checkbox'"
					@FitColumns="table.head=$event" @listenToChild="listenToChild"></c-table>
				
			</div>
		</div>
		<!-- zr 行复制 -->
		<vxe-modal ref="CreateModal" title="生成标签" :zIndex="2000" :loading="createLabelLoad" width="90%" height="60%"
			:before-hide-method="labelmodal_hide" :draggable="false"
			remember>
			<template v-slot:header>
				<span class="filter_item flex flex_row flex-nowrap flex-vc" style="display: inline;">
					<span>标签模板</span>
					<el-select v-model="printMoudle" :disabled="IsMatch">
						<el-option v-for="(item,index) in moduleList" :key="index" :value="item['FTNumber']"
							:label="item['FTName']"></el-option>
					</el-select>
				</span>
				<vxe-button type="text" class="tool-btn _icon_button" title="行删除" @click="labeldeleteLine"
					v-show="activeName=='first'" 	:disabled="createLabelLoad||createLoad||createCode.isCreated||calcuteLoad">
					<i class="iconfont icon-shanchu iconSize "></i>行删除
				</vxe-button>
				<vxe-button type="text" class="tool-btn _icon_button" title="行复制" @click = "labelcopy"
					v-show="activeName=='first'" 	:disabled="createLabelLoad||createLoad||createCode.isCreated||calcuteLoad">
					<i class="iconfont icon-copy iconSize "></i>行复制
				</vxe-button>
				<vxe-button type="text" class="tool-btn _icon_button trigger--btn" title="生成标签"
					v-show="activeName=='first'"  :loading="createLoad" @click="CREATElabelfn"
					:disabled="createLabelLoad||createLoad||createCode.isCreated||calcuteLoad">
					<i class="iconfont icon-create iconSize "></i>生成标签
				</vxe-button>
				<!-- <vxe-button type="text" class="tool-btn _icon_button testbtn trigger--btn" title="生成标签1"
					v-show="activeName=='first'"  :loading="createLoad" @click="test"
					:disabled="createLabelLoad||createLoad||createCode.isCreated||calcuteLoad">
					<i class="iconfont icon-create iconSize "></i>生成标签1
				</vxe-button> -->
				<vxe-button type="text" class="tool-btn _icon_button " title="标签打印"
					v-show="activeName!='first'" :loading="printLoad" @click="labelPrinttwodata"
					:disabled="createLabelLoad||printLoad||calcuteLoad">
					<i class="iconfont icon-print iconSize "></i>标签打印
				</vxe-button>
				<vxe-button type="text" class="tool-btn _icon_button" title="退出"
					:disabled="createLabelLoad||createLoad||calcuteLoad" @click="showCreateModal(false)">
					<i class="iconfont icon-close iconSize "></i>退出
				</vxe-button>
			</template>
			<template v-slot>
				<el-tabs ref="eltabs" v-model="activeName" @tab-click="TABCHANGE">
					<el-tab-pane label="标签打印信息" name="first"></el-tab-pane>
					<el-tab-pane label="本次生成标签" name="second"></el-tab-pane>
					<el-tab-pane label="最小包装标签" name="third" v-if="CanZT"></el-tab-pane>
					<el-tab-pane label="箱标签" name="four" v-if="CanZT"></el-tab-pane>
					<!-- <el-tab-pane label="历史已生成标签" name="third"></el-tab-pane> -->
				</el-tabs>
				<!-- {{createCode.key}}/{{createCode.key+1}}/{{createCode.key+2}} -->
				<el-main class="pursh_main asnDeatail_createdLabel" style="height: calc(100% - 2.8rem);">
					<c-table v-if="activeName=='first'" ref="ctablecreate"
						key="1"
						:table="createCode.table"
						style="height: calc(100% - 1.6rem);" @FitColumns="createFit"
						class="table_height print_selecttable_div"
						@listenToChild="listenToChild2" @loading="calcuteLoad=$event"
						coltype="seq" >
					</c-table>
					<c-table v-if="activeName=='second'" ref="ctablecreated"
						key="2"
						:table="createCode.tabled"
						style="height: calc(100% - 1.6rem);" @FitColumns="createFit"
						class="table_height print_selecttable_div"
						@listenToChild="listenToChild2"
						coltype="seq" >
					</c-table>
					<c-table v-if="activeName=='third'" ref="ctablecreated_package"
						key="3"
						:table="createCode.packageTable"
						style="height: calc(100% - 1.6rem);" @FitColumns="createFit"
						class="table_height print_selecttable_div"
						coltype="seq" >
					</c-table>
					<c-table v-if="activeName=='four'" ref="ctablecreated_zt"
						key="4"
						:table="createCode.ztTable"
						style="height: calc(100% - 1.6rem);" @FitColumns="createFit"
						class="table_height print_selecttable_div"
						coltype="seq" >
					</c-table>
					<!-- <c-table v-if="activeName=='third'" ref="ctablecreatedList"
						key="3"
						:table="createCode.tableList"
						style="height: calc(100% - 1.6rem);" @FitColumns="createFit"
						@listenToChild="listenToChild" class="table_height print_selecttable_div"
						coltype="checkbox" >
					</c-table> -->
				</el-main>
			</template>
		</vxe-modal>
		<vxe-modal ref="CreatedModal" title="已生成标签查看" :zIndex="2000" :loading="createLabelLoad" width="90%" height="60%"
			:before-hide-method="labelmodal_hide" :showHeader="true"
			remember>
			<template v-slot:header>
				<span class="filter_item flex flex_row flex-nowrap flex-vc" style="display: inline;">
					<span style="font-weight: 600;">标签模板</span>
					<el-select v-model="printMoudle"  :disabled="!createdChangeP">
						<el-option v-for="(item,index) in moduleList" :key="index" :value="item['FTNumber']"
							:label="item['FTName']"></el-option>
					</el-select>
				</span>
				<el-checkbox style="margin-left: 12px;margin-right: 12px;" v-model="createdChangeP" :disabled="createLabelLoad||IsMatch">切换模板</el-checkbox>
				<vxe-button type="text" class="tool-btn _icon_button" title="标签打印"
					:loading="printLoad" @click="labelPrinttwodata"
					:disabled="createLabelLoad||printLoad">
					<i class="iconfont icon-print iconSize "></i>标签打印
				</vxe-button>
				<vxe-button type="text" class="tool-btn _icon_button" title="作废标签" @click="UNVAILVADA"
					:loading="UNVAILVDALOAD" 
					:disabled="createLabelLoad||UNVAILVDALOAD" v-if="!IsCGY">
					<i class="iconfont icon-shanchu iconSize "></i>作废标签
				</vxe-button>
				<vxe-button type="text" class="tool-btn _icon_button" title="退出"
					:disabled="createLabelLoad" @click="VDAPRCreatedFnClose">
					<i class="iconfont icon-close iconSize "></i>退出
				</vxe-button>
			</template>
			<template v-slot>
				<el-main class="pursh_main" style="height: calc(100% - 1.6rem);">
					<c-table ref="ctablecreatedList"
						key="3"
						:table="createCode.tableList"
						style="height: calc(100% - 1.6rem);" @FitColumns="createFit"
						@listenToChild="listenToChild2" class="table_height print_selecttable_div"
						coltype="checkbox" :colfilter="true" >
					</c-table>
				</el-main>
			</template>
		</vxe-modal>
	</div>
</template>

<script>
	import print from './print.js'
	export default{
		name:'Pursh',
		props:{
			pageId: {
				type: String,
				default:''
			},
		},
		data(){
			return{
				filterForm: {},
                filterList:[],
				table: {
					pagesize: 100,
					currentPage: 1,
					head: [],
					data: [],
					_height: undefined
				},
				selectLog:false,
				planList:{},
				pLoad:false,
				DoLoad:false,
				AntiLoad:false,
				checkList:[],
				transLoad:false,
				NextDoc:'',
				HashPlan:false
			}
		},
		mixins:[print],
		computed:{
			userinfo() {
				return this.$store.getters.UserInfo;
			},
			
		},
		methods:{
			//生成ASN发运
			//需要校验选中行的状态
			//控制ASN已经确认后才可以做单
			TransDoRequest(){
				try{
					if(this.checkList.length==0)
						throw '请先选择行';
					//for(let i in this.checkList){
					//	if(this.checkList[i]['确认状态']=='未确认'||!this.checkList[i]['_fid'])
					//		throw '请先发布以后制作送货单单据';
					//}
					if(this.transLoad) return;
					this.transLoad=true;
					this.$BH().base.http({
						url:'Web/GetASN',
						data:{
							FUser:this.userinfo.pfnumber,
							FGYSNumber:this.userinfo.fnumber,
							dtView:this.checkList,
							FType:this.userinfo.accountType,
						},
						success:(res)=>{
							this.$tab.openSpecTab('送货单明细页面','asnDetail',{
								order:res.data.value,
								isadd:true
							})
						},
						loadingcontrol:()=>{
							this.transLoad=false;
						}
					});
				}catch(e){
					//TODO handle the exception
					this.transLoad=false;
					this.$BH().message(e);
				}
			},
			DoRequest(sign){
				try{
					//检查是否有选中行
					if(this.checkList.length==0)
						throw '请先选择行';
					for(let i in this.checkList){
						if(sign==1&&this.checkList[i]['确认状态']=='已确认')
							throw '选择行中存在已确认数据';
						else if(sign==0&&this.checkList[i]['确认状态']=='未确认')
							throw '选择行中存在未确认数据';
					}
					if(this.AntiLoad||this.DoLoad) return
					if(sign==1)
						this.DoLoad=true;
					else this.AntiLoad=true;
					this.$BH().base.http({
						url:'Web/updateOrder',
						data:{
							FUser:this.userinfo.pfnumber,
							FGYSNumber:this.userinfo.fnumber,
							dtView:this.checkList,
							FType:this.userinfo.accountType,
							FOrderState:sign,
							pageId:this.pageId
						},
						success:(res)=>{
							// for(let i in this.checkList){
							// 	this.checkList[i]['确认状态']=sign==1?'已确认':'未确认';
							// }
							
							this.$BH().message(res.data.value);
							this.selectOrder()
						},
						loadingcontrol:()=>{
							if(sign==1)
								this.DoLoad=false;
							else this.AntiLoad=false;
						}
					});
				}catch(e){
					this.$BH().message(e);
					if(sign==1)
						this.DoLoad=false;
					else this.AntiLoad=false;
				}
			},
			listenToChild(e){
				if(e&&e['rowdbClick']){
					// console.log(e['rowdbClick'])
					// //双击打开详情页
					// this.$tab.openSpecTab('EDI订单明细查询','EDIDetail',{
					// 	order:e['rowdbClick']
					// })
				}else if(e&&e.checkList){
					this.checkList=e.checkList;
				}
			},
			selectOrder(){
				try{
					if(this.selectLog) return;
					this.selectLog=true;
					this.$BH().base.http({
						url:'Web/PrintDataSelect_CG',
						data:{
							filterList:this.filterList,
							filterForm:this.filterForm,
							FUser:this.userinfo.pfnumber,
							gysFUser:this.userinfo.fnumber,
							FType:this.userinfo.accountType,
							pageId:this.pageId
						},
						success:(res)=>{
							// console.log(res)
							let {value}=res.data;
							this.table.data=value.data;
                            this.table.head = (value.head || []).filter(item => !item['allowUser'] || item['allowUser'].split(',').findIndex(jitem => jitem == this.userinfo.accountType)>-1);
							// console.log(value.data>0)
							if(value.data.length>0)
								this.$refs.ctablemain?.updateCoulm();
							this.$refs.ctablemain?.clearSelection();
							this.checkList=[]
						},
						loadingcontrol:()=>{
							this.selectLog=false;
						}
					})
				}catch(e){
					//TODO handle the exception
					this.$BH().message(e);
					this.selectLog=false;
				}
			},
			PageInit() {
				try {
                    this.pLoad = true;
                    this.$BH().base.http({
                        url: 'Web/PrintData_Init',
                        data: {
                            FUser: this.userinfo.pfnumber,
                            gysFUser: this.userinfo.fnumber,
                            FType: this.userinfo.accountType,
							pageId:this.pageId
                        },
                        success: (res) => {
                            // console.log(res)
                            let { value } = res.data;
                            this.filterList = value.filterList||[];
							this.HashPlan=value.hasplan;
                        },
                        loadingcontrol: () => {
                            this.pLoad = false;
                        }
                    })
				} catch (e) {
                    this.$BH().message(e);
                    this.pLoad = false;
                    
                }
			},
            filterShow(filterItem) {
                if (filterItem.allowUser) {
                    let users = (filterItem.allowUser || '').split(',');
                    let Index = users.findIndex(item => item == this.userinfo.accountType)
                    return Index > -1;
                }
                // return true;
				return !filterItem['hide'] ;
            }
		},
		mounted() {
			setTimeout(()=>{
				this.$refs.ctablemain?.updateCoulm();
			},0);
			
			console.log(1,$(this.$refs.CreateModal.$el).find('.vxe-modal--header'))
			let header=$(this.$refs.CreateModal.$el).find('.vxe-modal--header')[0];
			console.log(header.events)
			if(header)
				for (var event in header.events) {
					if (Object.prototype.hasOwnProperty.call(header.events,event)) {
						console.log(event,2)
						delete header.events[event];
					}
				}
		},
		created() {
			this.PageInit();
			// this.table.head=tablehead;
		}
	}
</script>

<style>
</style>